<template>
  <section>
    <qx-search-box
      class="searchBox"
      ref="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      @reset="reset"
      title="筛选"
      permpisionsQuery=""
    >
      <div slot="isAuthState" slot-scope="prop">
        <el-checkbox
          label="待审核"
          name="type"
          v-model="prop.form.isAuthState"
        />
      </div>
    </qx-search-box>
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  getDepartmentAllList,
  getEnumList,
  getCarTypeList,
} from 'api';
import {mapState} from 'vuex';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        // 车辆种类
        vehicleClassOptions: [],
        // 认证状态
        authStateInOptions: [],
        // 定位类型
        vehicleGpsOptions: [],
        // 使用状态
        vehicleStateOptions: [],
        // 归属部门
        orgIdOptions: [],
        // 车辆类型
        vehicleStatusOptions: [],
        // 能源类型
        energyTypeOptions: [],
        form: [
          {
            label: '',
            value: 'authStateIn',
            type: 'radio',
            default: -1,
            class: 'especial-radio-group',
            normalFormNotCount: true,
            onChangeRadio: () => {
              this.$refs.searchBox.sub();
            },
          },
          {
            label: '车牌号码',
            value: 'plateNumber',
            type: 'input',
            placeholder: '请输入车牌号码',
          },
          {
            label: '主驾姓名',
            value: 'linkman',
            type: 'input',
            placeholder: '请输入主驾姓名',
          },
          {
            label: '车辆种类',
            value: 'vehicleClass',
            type: 'select',
            default: '1',
            placeholder: '车辆种类',
          },
          {
            label: '主驾手机',
            value: 'mobilePhone',
            type: 'input',
            default: this.$route.query.mobilePhone,
            placeholder: '请输入主驾手机',
          },
          {
            label: '归属部门',
            value: 'orgId',
            type: 'select',
            default: -1,
            placeholder: '请输入归属部门',
          },
          {
            label: '归属车队',
            value: 'tenantName',
            type: 'input',
            placeholder: '请输入归属车队',
          },
          {
            label: '车队手机',
            value: 'linkPhone',
            type: 'input',
            placeholder: '请输入车队手机',
          },
          {
            label: '定位类型',
            value: 'vehicleGps',
            type: 'select',
            default: -1,
            placeholder: '请输入定位类型',
          },
          {
            label: '定位日期',
            value: 'bdDate',
            type: 'date',
            placeholder: '请输入定位日期',
            attr: {
              type: 'daterange',
            },
          },
          {
            label: '使用状态',
            value: 'vehicleState',
            type: 'select',
            default: -1,
            placeholder: '请输入使用状态',
          },
          {
            label: '车辆类型',
            value: 'vehicleStatus',
            type: 'cascader',
            normal: true,
            default: [],
          },
          {
            label: '能源类型',
            value: 'energyType',
            type: 'select',
            default: -1,
            placeholder: '',
          },
        ],
      },
    };
  },
  watch: {
    '$route.query.mobilePhone': function (newVal) {
      if (this.$route.path === '/manage/car/archives/my' && newVal) {
        this.$refs.searchBox.setVal('mobilePhone', newVal);
        this.$refs.searchBox.sub();
      }
    },
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo, // 用户信息
    }),
  },
  methods: {
    reset (val) {
      if (val === 'reset') {
        this.$refs.searchBox.setVal('mobilePhone', '');
      }
    },

    sub (searchBoxData) {

      // 定位日期
      if (searchBoxData.bdDate && searchBoxData.bdDate.length > 0) {
        searchBoxData.bdEffectDate = this.formatDate(searchBoxData.bdDate[0]);
        searchBoxData.bdInvalidDate = this.formatDate(searchBoxData.bdDate[1]);
        delete searchBoxData.bdDate;
      }

      if (Array.isArray(searchBoxData.vehicleStatus) && searchBoxData.vehicleStatus.length) {
        const tempVehicleStatus = JSON.parse(JSON.stringify(searchBoxData.vehicleStatus));
        searchBoxData.vehicleStatus = tempVehicleStatus[0];
        searchBoxData.vehicleLength = tempVehicleStatus[1];
      } else {
        searchBoxData.vehicleStatus = -1;
      }
      searchBoxData.energyType = searchBoxData.energyType === -1 ? '' : String(searchBoxData.energyType);
      // 待审核要多传一个字段才行，有点不理解
      searchBoxData.isAuth = searchBoxData.isAuthState ? '1' : '-1';
      this.$refs.tableBox.saveSearchBoxData({
        shareFlgIn: -1,
        vehicleLength: -1,
        ...searchBoxData,
      });
    },
  },
  async created () {
    const enumsList = await getEnumList({
      codeType: 'VEHICLE_CLASS,TENANT_VEHICLE_REL.AUTHSTATE,VEHICLE_GPS_TYPE,VEHICLE_STATE,ENERGY_TYPE',
    });
    const safeEnum = (index) => (Array.isArray(enumsList) && Array.isArray(enumsList[index])) ? enumsList[index] : [];
    let vehicleClassOptions = [];
    for (let item of safeEnum(0)) {
      if (item.value !== '3') {
        // 这里下拉要屏蔽临时外调车
        vehicleClassOptions.push(item);
      }
    }
    this.searchBoxData.vehicleClassOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...vehicleClassOptions,
    ];
    this.searchBoxData.authStateInOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...safeEnum(1),
    ];
    this.searchBoxData.vehicleGpsOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...safeEnum(2),
    ];
    this.searchBoxData.vehicleStateOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...safeEnum(3),
    ];
    this.searchBoxData.orgIdOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...(await getDepartmentAllList({
        isArchive: true,
      }) || []),
    ];
    this.searchBoxData.vehicleStatusOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...(await getCarTypeList() || []),
    ];
    this.searchBoxData.energyTypeOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...safeEnum(4),
    ];
  },
};
</script>

<style scoped lang="scss">
.vehicleStatus-select {
  display: flex;
}
</style>
